
<template>
  <div class="com-iframe" v-html="dataInfo.html" :style="cardStyle"></div>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin'
const IFRAME_SRC_HOST_WHITE_SET = [
    'www.bilibili.com',
    'bilibili.com',
    'player.bilibili.com',
    'v.qq.com',
    'open.iqiyi.com',
    'player.youku.com',
    'music.163.com',
]
export default {
  mixins: [CptMixin],
  computed: {
    cardStyle () {
      return {
        width: this.dataInfo.width + 'px',
        height: this.dataInfo.height + 'px',
        visibility: IFRAME_SRC_HOST_WHITE_SET.find(host => this.dataInfo.src.includes(host))
      }
    }
  }
}
</script>

<style lang="less">
.com-iframe {
  visibility: inherit;
  min-height: auto;
  margin: 12px 0 0;
  font-size: 16px;
  line-height: 25px;
}
</style>